import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const setupCriticalResources = () => {
  // Preconnect to CDN (faster than dns-prefetch — establishes full connection)
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = 'https://cdn.magicpatterns.com';
  preconnect.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect);
  // Preconnect to payment domain — warm connection before user clicks CTA
  const hotmartPreconnect = document.createElement('link');
  hotmartPreconnect.rel = 'preconnect';
  hotmartPreconnect.href = 'https://pay.hotmart.com';
  document.head.appendChild(hotmartPreconnect);
  // DNS prefetch for Facebook pixel domain
  const fbDns = document.createElement('link');
  fbDns.rel = 'dns-prefetch';
  fbDns.href = 'https://connect.facebook.net';
  document.head.appendChild(fbDns);
  // Preload hero image — WebP format (LCP optimization)
  const heroPreload = document.createElement('link');
  heroPreload.rel = 'preload';
  heroPreload.as = 'image';
  heroPreload.type = 'image/webp';
  heroPreload.href = 'https://cdn.magicpatterns.com/uploads/fPHA9Qc9ZQ8HbPsQE6fMKT/LIBRO_EL_REINICIO_BIOLOGICO_2B_BONOS_(1)_(1).webp';
  heroPreload.fetchPriority = 'high';
  document.head.appendChild(heroPreload);
};
setupCriticalResources();
render(<App data-id="element-149" />, document.getElementById('root'));